import React from 'react';
import {Line} from 'react-chartjs-2';
import {Row, Col} from 'react-bootstrap';
import {jsUcfirst} from '../../util/utils';


const AnalysisChart = (props) =>{

  let scoreArray = props.data.score.filter(val=>val.correct_num!==-1);
  let count = scoreArray.length;
  let labels=[];
  // creating X-axis
  let scores=[];

  for(let i=0; i<scoreArray.length ;i++){
    let {week_num, correct_num, question_num} = scoreArray[i];
    labels.push('week '+ week_num);
    scores.push(parseFloat(correct_num/question_num*100).toFixed(0));
  }

  let data = {
    labels: labels,
    datasets :[{
      label: 'Your Scores',
      data: scores,
      fill: false,
      lineTension: 0.1,
      backgroundColor: '#6be1cc',
      borderColor: '#6be1cc',
    }],
  };

  let options ={
    legend: {
      display: false,
      // position: 'top',
      // beginAtZero: true
    },
    scales:{
      yAxes: [{
        id: 'y-axis-0',
        ticks: {
          min: 0,
          beginAtZero: true,
          max :100,
          stepSize: 10
        }
      }],
      xAxes: [{
        id: 'x-axis-0',
        gridLines : {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      }]
    },
    //https://stackoverflow.com/questions/34720530/chart-js-v2-add-prefix-or-suffix-to-tooltip-label
    //https://stackoverflow.com/questions/37332593/chart-js-2-0-how-to-change-default-appearance-of-canvas-chart-elements

    tooltips:{
      custom: function(tooltip) {
        if (!tooltip) return;
        // disable displaying the color box;
        tooltip.displayColors = false;
      },
      callbacks: {
        title: function (tooltipItem, data){ return data.labels[tooltipItem[0].index];},
        label: function (tooltipItem, data){
          var score = '  점 수  : '+ tooltipItem.yLabel;
          var firstLabel = '  문제 수: '+ scoreArray[tooltipItem.index].question_num;
          var secondLabel = '  정답 수: '+ scoreArray[tooltipItem.index].correct_num;
          var tooltip = [score, firstLabel, secondLabel];
          return tooltip;
        }
      }
    },
    maintainAspectRatio: false,
  };


  return(
      <Row className="analysisChart">
        <Col xs={12}>
          <Row className="text-left">
            <Col xs={12}>
              <span>{jsUcfirst(props.data.type)}</span>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="chart_wrapper">
                <div className="chartAreaWrapper">
                  <div style={count>10?
                        {width:props.width*count}:{width:'100%'}}>
                    <Line data={data} options={options} height={300}/>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};

export default AnalysisChart;



// WEBPACK FOOTER //
// ./src/components/charts/AnalysisChart.js